/**
 * useMediaQuery Hook
 * Detects viewport against a CSS media query string.
 */

import { useState, useEffect } from 'react';

export function useMediaQuery(query: string): boolean {
    const [matches, setMatches] = useState(() => {
        if (typeof window === 'undefined') return false;
        return window.matchMedia(query).matches;
    });

    useEffect(() => {
        const mql = window.matchMedia(query);
        const handler = (e: MediaQueryListEvent) => setMatches(e.matches);

        mql.addEventListener('change', handler);
        setMatches(mql.matches);

        return () => mql.removeEventListener('change', handler);
    }, [query]);

    return matches;
}
